module.exports = __webpack_public_path__ + "img/empty.37942c7e.png";